export const PRACTICE_AREA_IDS = [
  'family-law',
  'criminal-defense',
  'personal-injury',
  'workers-compensation',
  'estate-planning-probate',
  'elder-law',
  'real-estate',
  'landlord-tenant',
  'business-corporate',
  'intellectual-property',
  'immigration',
  'employment-labor',
  'bankruptcy-debt',
  'tax-law',
  'civil-litigation',
  'consumer-protection',
  'social-security-disability',
  'administrative-government',
  'military-veterans',
] as const;

export type PracticeAreaId = (typeof PRACTICE_AREA_IDS)[number];

export const PRACTICE_AREA_LABELS: Record<PracticeAreaId, string> = {
  'family-law': 'Family Law',
  'criminal-defense': 'Criminal Defense',
  'personal-injury': 'Personal Injury',
  'workers-compensation': 'Workers Compensation',
  'estate-planning-probate': 'Estate Planning & Probate',
  'elder-law': 'Elder Law',
  'real-estate': 'Real Estate',
  'landlord-tenant': 'Landlord-Tenant',
  'business-corporate': 'Business & Corporate',
  'intellectual-property': 'Intellectual Property',
  immigration: 'Immigration',
  'employment-labor': 'Employment & Labor',
  'bankruptcy-debt': 'Bankruptcy & Debt',
  'tax-law': 'Tax Law',
  'civil-litigation': 'Civil Litigation',
  'consumer-protection': 'Consumer Protection',
  'social-security-disability': 'Social Security Disability',
  'administrative-government': 'Administrative / Government',
  'military-veterans': 'Military / Veterans',
};

export const PRACTICE_AREAS: readonly { id: PracticeAreaId; label: string }[] =
  PRACTICE_AREA_IDS.map((id) => ({ id, label: PRACTICE_AREA_LABELS[id] }));

export const MAX_PRACTICE_AREAS_PER_ORG = 10;
